import React from 'react'
import { Box, Link, styled } from '@mui/material'
import { Spinner } from 'packages/eid-ui'

const StyledBox = styled(Box)(({ theme, ...props }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.5rem',
    width: props.width,
    minHeight: props.height,
    paddingLeft: '0.8rem',
    paddingRight: props.paddingRight || '0.8rem',
    backgroundColor: props.disabled ? '#d0d9e2' : props.bgColor,
    border: props.border,
    color: props.fontColor ? props.fontColor : '#ffffff',
    height: 'unset !important',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    '&:hover': {
        cursor: props.disabled ? 'initial' : 'pointer',
        backgroundColor: props.hoverColor,
    },
}))

const DrawerActionButton = (props) => {
    const {
        width,
        height,
        bgColor,
        hoverColor,
        border,
        fontColor,
        children,
        loading,
        onClick,
        disabled,
        loaderColor,
        paddingRight,
    } = props

    return (
        <Link
            component="button"
            underline="none"
            onClick={disabled ? undefined : onClick}
            style={{ width: width ? width : '100%' }}
        >
            <StyledBox
                width={width}
                height={height}
                bgColor={bgColor}
                border={border}
                fontColor={fontColor}
                hoverColor={hoverColor}
                disabled={disabled}
                paddingRight={paddingRight}
            >
                {loading && <Spinner size={0.8} color={loaderColor} />}
                {!loading && children}
            </StyledBox>
        </Link>
    )
}

DrawerActionButton.defaultProps = {
    width: '10rem',
    minHeight: '4.8rem',
    bgColor: '#ffffff',
    border: 'none',
    loaderColor: '#ffffff',
}

export default DrawerActionButton
